import ekozAxios from './instance/axios';

export const getUserMessages = (pageRoute) => ekozAxios.request({
  method: 'get',
  url: '/admin/intercom/get_user_messages',
  params: {
    page_route: pageRoute,
  },
});

export const dismissMessage = (messageId) => ekozAxios.request({
  method: 'post',
  url: '/admin/intercom/dismiss_message',
  data: {
    message_id: messageId,
  },
});
